import angular from 'angular';
import template from './patient-modal-name.html';
import * as devices from '../../../modules/devices';
import PatientPhotoCaptureNotification from '../patient-photo-capture-notification/patient-photo-capture-notification';
let isAutoCheckInUsed = false;
class ModalPatientModalNameController {
    constructor(patientService, trackingFactory, notificationFactory, checkInPlaceholderService, Room, $stateParams, $translate, $ngRedux) {
        this.patientService = patientService;
        this.trackingFactory = trackingFactory;
        this.notificationFactory = notificationFactory;
        this.checkInPlaceholderService = checkInPlaceholderService;
        this.Room = Room;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.$ngRedux = $ngRedux;
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis)(this);
    }
    async $onInit() {
        this._initPlaceholder();
        if (isAutoCheckInUsed)
            return;
        if (!this.patient.username)
            return;
        if (this.$stateParams.transfer) {
            this.patientService.notifyTransferSenderAboutSuccessfulTransfer(this.room.id);
        }
        if (this.shouldUsePasscode())
            return;
        if (!this.$stateParams.autocheckin)
            return;
        if (this.shouldUseTos() && !this.$stateParams.autocheckin)
            return;
        if (!this.hasMediaAccess && !this.$stateParams.autocheckin)
            return;
        if (this.$stateParams.autocheckin) {
            this.agreeOnTosUrl();
        }
        else {
            sessionStorage.removeItem('TOS');
        }
        setTimeout(() => {
            this.checkIn();
            isAutoCheckInUsed = true;
        }, 1000);
    }
    switchTosUrl($event) {
        $event.preventDefault();
        if ($event.charCode === 13) {
            this.patient.tosURL = !this.patient.tosURL;
        }
    }
    agreeOnTosUrl() {
        const previous = sessionStorage.getItem('TOS') || null;
        this.patient.tosURL = previous === this.room.tosURL;
    }
    shouldUsePasscode() {
        return this.room.usePasscode && this.roomAdminCanUsePaidFeatures === true;
    }
    shouldUseTos() {
        return this.room.tosURL;
    }
    checkIn() {
        this.trackingFactory.global.track('Checkin Started', {
            user_type: 'patient',
            checkin_type: 'classic',
            room_id: this.room.id,
            plan_type: undefined,
        });
        if (this.form.$invalid)
            return;
        this.patient.passcode = this.passcode;
        if (!this.$stateParams.autocheckin) {
            sessionStorage.setItem('TOS', this.room.tosURL);
        }
        this.patientService
            .checkPasscode(this.room, this.patient.passcode)
            .then(() => {
            if (this.hasMediaAccess || this.$stateParams.autocheckin) {
                this.onCheckIn();
            }
            else {
                this.onNoMediaAccess();
            }
        })
            .catch((err) => {
            this.notificationFactory.showCommon('error', err.message);
        });
    }
    _initPlaceholder() {
        // TODO use helper landing-page-rooms-check-in.helper instead of angular service
        this.checkInPlaceholder = this.checkInPlaceholderService.getText(this.currentInstitution.checkInPlaceholder);
    }
    mapStateToThis(state) {
        return { hasMediaAccess: devices.selectors.hasMediaAccess(state) };
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const patientModalName = {
    template,
    bindings: {
        onNoMediaAccess: '&',
        room: '<',
        patient: '<',
        onCheckIn: '&',
        checkInPromise: '<',
        roomAdminCanUsePaidFeatures: '<',
        currentInstitution: '<',
    },
    controller: ModalPatientModalNameController,
};
export default angular
    .module('doxy.patient.modal.patientModalName', [
    PatientPhotoCaptureNotification,
])
    .component('patientModalName', patientModalName).name;
